import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";
import course05 from "../../../course/course-05/course";
import lesson0505 from "../../course-05/lesson-05/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "f3b0285f-4e93-45ea-9775-805475eb3813",
    course: {
      id: course05.id,
      slug: course05.slug as string,
      name: course05.name,
      publicId: course05.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course05, lesson0505),
    lesson: lesson0505,
  },
];

export default lessonLinks;
